import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-marketing-header',
  templateUrl: './marketing-header.component.html',
  styleUrls: ['./marketing-header.component.scss']
})
export class MarketingHeaderComponent implements OnInit, OnDestroy {
  menuOpen = false;

  constructor(private router: Router) { }

  ngOnInit(): void {
    // nothing for now; HostListener handles keydown
  }

  ngOnDestroy(): void {
    // cleanup if needed
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.menuOpen = false;
  }

  navigateToLogin() {
    this.menuOpen = false;
    this.router.navigate(['/login']);
  }

  navigateToLanding() {
    this.menuOpen = false;
    this.router.navigate(['/landing']);
  }

  navigateToAbout() {
    this.menuOpen = false;
    this.router.navigate(['/about-us']);
  }

  navigateToStudents() {
    this.menuOpen = false;
    this.router.navigate(['/students']);
  }

  navigateToSchools() {
    this.menuOpen = false;
    this.router.navigate(['/schools']);
  }

  navigateToTeachers() {
    this.menuOpen = false;
    this.router.navigate(['/teachers']);
  }

  navigateToBusinesses() {
    this.menuOpen = false;
    this.router.navigate(['/businesses']);
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    if (this.menuOpen) {
      this.menuOpen = false;
      keyboardEvent.stopPropagation();
    }
  }
}
